import { useState } from "react";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";

const useFileUpload = () => {
  const uploadFile = async (file, setIsLoading) => {
    let token = localStorage.getItem("accessToken");
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("singleMedia", file);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${Api_Url}/uploads/single?singleMedia`, // Add http://
        headers: {
          "Content-Type": "multipart/form-data",
          ...(token && { Authorization: `Bearer ${token}` }), // Add token if provided
        },
        data: formData,
      };

      const response = await axios.request(config);

      // Assuming the response contains a URL field
      // Adjust this based on your actual response structure
      const fileUrl =
        response.data.url || response.data.fileUrl || response.data;
      setIsLoading(false);

      return fileUrl;
    } catch (err) {
      setIsLoading(false);
      console.error("Upload error:", err);
      return err.message;
    }
  };

  return {
    uploadFile,
  };
};

export default useFileUpload;
